export enum AttachmentExtensionEnum {
  JPEG = "JPEG",
  JPG = "JPG",
  PNG = "PNG",
  PDF = "PDF"
}
